import React, { useState, useEffect } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { Formik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import {
  plansList,
  resetplansList,
  updateplans,
  getTaxgsts,
  getServices,
} from "../../reducers/commonReducer";


const schema = yup.object().shape({
  name: yup.string().required("Name is required."),
  description: yup.string().required("Description is required."),
  mrp: yup.string().required("MRP is required."),
  sale: yup.string(),
  timeperiod: yup.string().required("Time period is required."),
  service: yup.string().required("Select at least one service."),
  status: yup.bool().required("Status is required."),
  benefits: yup.array().of(yup.string().required("Benefit is required.")),
});

const generateSlug = (value) => {
  return value.toLowerCase().replace(/ /g, "-").replace(/[^\w-]+/g, "");
};

function PlansUpdate({
  pname = "",
  pdescription = "",
  pmrp = "",
  psale = "",
  ptax_class = "63b53729a403053ba0d99d99",
  ptimeperiod = "",
  id,
  pstatus = true,
  pservice = "",
  pbenefits = [],
}) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
    dispatch(getTaxgsts());
    dispatch(getServices());
  };

  const { getTaxgstsData, getServicesData } = useSelector(
    (state) => state.commonReducer
  );


  const [benefits, setBenefits] = useState(pbenefits);


  const handleAddBenefit = () => {
    setBenefits([...benefits, ""]);
  };


  const handleBenefitChange = (index, event) => {
    const updatedBenefits = benefits.map((benefit, i) =>
      i === index ? event.target.value : benefit
    );
    setBenefits(updatedBenefits);
  };


  const handleRemoveBenefit = (index) => {
    const updatedBenefits = benefits.filter((_, i) => i !== index);
    setBenefits(updatedBenefits);
  };

  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        <i className="bi bi-pencil-square"></i>
      </Button>

      <Modal className="modal-xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Product</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Formik
            enableReinitialize
            validationSchema={schema}
            initialValues={{
              name: pname,
              description: pdescription,
              mrp: pmrp,
              sale: psale,
              timeperiod: ptimeperiod,
              service: pservice,
              tax_class: ptax_class,
              status: pstatus,
              benefits: benefits,
            }}
            onSubmit={async (values) => {
              await dispatch(updateplans({ ...values, id }));
              await dispatch(resetplansList());
              await dispatch(plansList());
              handleClose();
            }}
          >
            {({ handleSubmit, handleChange, values, setFieldValue, errors }) => (
              <Form onSubmit={handleSubmit}>

                <Row className="mb-3">
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="name"
                        value={values.name}
                        onChange={(e) => {
                          handleChange(e);
                          setFieldValue("slug", generateSlug(e.target.value));
                        }}
                        isInvalid={!!errors.name}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.name}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={5}>
                    <Form.Group>
                      <Form.Label>Description</Form.Label>
                      <Form.Control
                        type="text"
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                        isInvalid={!!errors.description}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.description}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>MRP</Form.Label>
                      <Form.Control
                        type="number"
                        name="mrp"
                        value={values.mrp}
                        onChange={handleChange}
                        isInvalid={!!errors.mrp}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.mrp}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Sale Price</Form.Label>
                      <Form.Control
                        type="number"
                        name="sale"
                        value={values.sale}
                        onChange={handleChange}
                        isInvalid={!!errors.sale}
                      />
                      <Form.Control.Feedback type="invalid">
                        {errors.sale}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>


                <Row className="mb-3">
                  <Col md={4}>
                    <Form.Label>Services</Form.Label>


                    <Select
                      name="service"
                      options={getServicesData?.list?.map((data) => ({
                        value: data?.id,
                        label: data?.name,
                      }))}
                      onChange={(selectedOption) => {

                        setFieldValue("service", selectedOption ? selectedOption.value : "");
                      }}
                      value={
                        values.service
                          ? {
                            value: values.service,
                            label: getServicesData?.list?.find(
                              (service) => service.id === values.service
                            )?.name,
                          }
                          : null
                      }
                      className={errors.service ? "is-invalid" : ""}
                      isInvalid={!!errors.service}
                      placeholder="Select Service"
                    />


                    <div className="invalid-feedback">{errors.service}</div>
                  </Col>

                  <Col md={3}>
                    <Form.Label>Tax Class</Form.Label>
                    <Form.Control
                      as="select"
                      name="tax_class"
                      onChange={handleChange}
                      value={values.tax_class}
                      isInvalid={!!errors.tax_class}
                    >
                      {getTaxgstsData?.list?.map((data) => (
                        <option value={data?.id} key={data?.id}>
                          {data?.name}
                        </option>
                      ))}
                    </Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.tax_class}
                    </Form.Control.Feedback>
                  </Col>

                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Time Period</Form.Label>
                      <Form.Control
                        as="select"
                        name="timeperiod"
                        value={values.timeperiod}
                        onChange={handleChange}
                        isInvalid={!!errors.timeperiod}
                      >
                        <option value="">Select Time Period</option>
                        <option value="yearly">Yearly</option>
                        <option value="monthly">Monthly</option>
                        <option value="quarterly">Quarterly</option>
                        <option value="six_monthly">6 Months</option>
                      </Form.Control>
                      <Form.Control.Feedback type="invalid">
                        {errors.timeperiod}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col md={2} sm={12}>
                    <Form.Label>Status</Form.Label>
                    <Form.Control
                      as="select"
                      controlId="validationFormik03"
                      onChange={async (e) => {
                        setFieldValue("status", e.target.value);
                      }}
                      name="status"
                      className="form-control"
                      value={values.status}
                      isInvalid={!!errors.status}
                    >
                      <option value="">Select Status</option>
                      <option value={true}>True</option>
                      <option value={false}>False</option>
                    </Form.Control>
                  </Col>
                </Row>


                <Row className="mt-3">
                  {benefits.map((benefit, index) => (
                    <Col md={12} key={index}>
                      <Form.Group>
                        <Form.Label>Benefit #{index + 1}</Form.Label>
                        <Form.Control
                          type="text"
                          name={`benefit${index}`}
                          value={benefit}
                          onChange={(e) => handleBenefitChange(index, e)}
                          isInvalid={!!errors.benefits && errors.benefits[index]}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors.benefits && errors.benefits[index]}
                        </Form.Control.Feedback>

                        {index > 0 && (
                          <Button
                            variant="danger"
                            size="sm"
                            className="mt-2 float-end"
                            onClick={() => handleRemoveBenefit(index)}
                          >
                            Remove Benefit
                          </Button>
                        )}
                      </Form.Group>
                    </Col>
                  ))}

                  <Col md={12} className="mt-3">
                    <Button variant="primary float-end" onClick={handleAddBenefit}>
                      Add Benefit
                    </Button>
                  </Col>
                </Row>


                <Row className="mt-3">
                  <Col>
                    <Button variant="success" type="submit">
                      Update Product
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PlansUpdate;






